
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AccountCompleteEmailVerification": [
      "AccountCompleteEmailVerificationErrorJWTExpired",
      "AccountCompleteEmailVerificationResponse",
      "Error"
    ],
    "AccountInitiateEmailVerificationPayload": [
      "AccountInitiateEmailVerificationError",
      "AccountInitiateEmailVerificationResponse"
    ],
    "AccountRemovePayload": [
      "AccountRemoveError",
      "AccountRemoveResponse"
    ],
    "AccountSuspendResponse": [
      "Error",
      "Response"
    ],
    "AccountUnsuspendResponse": [
      "Error",
      "Response"
    ],
    "AccountUpdateRoleResponse": [
      "Error",
      "Response"
    ],
    "AddEntityNotePayload": [
      "AddEntityNoteResponse",
      "CoreWebAppCommonError"
    ],
    "AddNoteToPostPayload": [
      "AddNoteToPostSuccess",
      "InvalidInputError",
      "LimitReachedError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "AddOrUpdateDismissedObjectPayload": [
      "AddOrUpdateDismissedObjectError",
      "AddOrUpdateDismissedObjectResponse"
    ],
    "AddPostToQueuePayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "ApprovePostPayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "Asset": [
      "DocumentAsset",
      "ImageAsset",
      "VideoAsset"
    ],
    "AuthorizeChannelsPayload": [
      "AuthorizeChannelsError",
      "AuthorizeChannelsResponse"
    ],
    "BackfillChannelPostsAndAnalyticsPayload": [
      "BasicError",
      "MutationBasicResponse"
    ],
    "BackfillChannelUpdatesResponse": [
      "Error",
      "Response"
    ],
    "BackfillUpdatesForGridPayload": [
      "BackfillUpdatesForGridResponse",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "BaseComment": [
      "CommentFromBuffer",
      "CommentFromThirdParty"
    ],
    "BaseResponse": [
      "Error",
      "Response"
    ],
    "Billing": [
      "MPBilling",
      "OBBilling"
    ],
    "BillingCreateCheckoutSessionPayload": [
      "BillingCreateCheckoutSessionResponse",
      "BillingError"
    ],
    "BillingCreateCustomerPortalSessionPayload": [
      "BillingCreateCustomerPortalSessionResponse",
      "BillingError"
    ],
    "BillingCreatedSetupIntentPayload": [
      "BillingCreateSetupIntentResponse",
      "BillingError"
    ],
    "BillingIncreaseSubscriptionQuantityByChannelIdsPayload": [
      "BillingError",
      "BillingResponse"
    ],
    "BillingMigrateToOneBufferPayload": [
      "BillingError",
      "BillingMigrateToOneBufferResponse"
    ],
    "BillingStartTrialPayload": [
      "BillingError",
      "BillingResponse"
    ],
    "BillingUpdateCustomerPaymentMethodPayload": [
      "BillingError",
      "BillingResponse"
    ],
    "BillingUpdateSubscriptionPlanPayload": [
      "BillingError",
      "BillingUpdateSubscriptionPlanResponse"
    ],
    "BillingUpdateSubscriptionQuantityPayload": [
      "BillingError",
      "BillingUpdateSubscriptionPlanResponse"
    ],
    "BlockMutationResponse": [
      "BlockMutationSuccess",
      "CommonError"
    ],
    "BlocksMutationResponse": [
      "BlocksMutationSuccess",
      "CommonError"
    ],
    "CalendarsPayload": [
      "Calendar",
      "PublishingError"
    ],
    "CancelTrialPayload": [
      "CancelTrialResponse",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "ChannelAnalyticsLastUpdateAtPayload": [
      "Error",
      "Response"
    ],
    "ChannelAuthorizationPayload": [
      "ChannelAuthorizationError",
      "ChannelAuthorizationResponse"
    ],
    "ChannelAuthorizationUrlPayload": [
      "ChannelAuthorizationUrlError",
      "ChannelAuthorizationUrlResponse"
    ],
    "ChannelConnectionListPayload": [
      "ChannelConnectionListResponse",
      "ChannelConnectionNoChannelsError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "ChannelConnectionRefreshPayload": [
      "ChannelConnectionCannotStealChannelError",
      "ChannelConnectionNoChannelsError",
      "ChannelConnectionRefreshResponse",
      "ChannelConnectionRefreshWrongAccountError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "ChannelGroupPayload": [
      "ChannelGroup",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "ChannelGroupsPayload": [
      "ChannelGroupsResponse",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "ChannelLinkShorteningPayload": [
      "ChannelLinkShortening",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "ChannelMetadata": [
      "BlueskyMetadata",
      "FacebookMetadata",
      "GoogleBusinessMetadata",
      "InstagramMetadata",
      "LinkedInMetadata",
      "MastodonMetadata",
      "PinterestMetadata",
      "TwitterMetadata"
    ],
    "ChannelMutationResponse": [
      "ChannelResponse",
      "Error"
    ],
    "ChannelStoreTemporaryCredentialsResponse": [
      "Error",
      "Response"
    ],
    "ChannelUpdateLockedStatusResponse": [
      "ChannelLimitError",
      "Error",
      "Response"
    ],
    "ChannelsConnectPayload": [
      "ChannelsConnectError",
      "ChannelsConnectResponse"
    ],
    "ChannelsSetRecommendationsPayload": [
      "ChannelsSetRecommendationsError",
      "ChannelsSetRecommendationsResponse"
    ],
    "ChannelsUpdateCredentialsResponse": [
      "Error",
      "Response"
    ],
    "ChecklistsPayload": [
      "ChecklistsResponse",
      "CoreWebAppCommonError"
    ],
    "ClientPayload": [
      "Client",
      "ClientError"
    ],
    "CommentData": [
      "CommentFromBuffer",
      "CommentFromThirdParty"
    ],
    "CommentOEmbed": [
      "OEmbedRich"
    ],
    "CommonPostMetadata": [
      "BlueskyPostMetadata",
      "FacebookPostMetadata",
      "GoogleBusinessPostMetadata",
      "InstagramPostMetadata",
      "LinkedInPostMetadata",
      "MastodonPostMetadata",
      "PinterestPostMetadata",
      "StartPagePostMetadata",
      "ThreadsPostMetadata",
      "TiktokPostMetadata",
      "TwitterPostMetadata",
      "YoutubePostMetadata"
    ],
    "CompleteEmailVerificationPayload": [
      "CompleteEmailVerificationSuccess",
      "UnexpectedError"
    ],
    "ConnectableServicesPayload": [
      "ConnectableServicesError",
      "ConnectableServicesResponse"
    ],
    "ConvertCustomChannelPayload": [
      "ConvertCustomChannelResponse",
      "CustomChannelError"
    ],
    "CoreWebAppError": [
      "CoreWebAppCommonError"
    ],
    "CoreWebAppMutationResponse": [
      "IdeaMutationSuccess",
      "IdeasDeletionSuccess",
      "PlaceholderIdeasMutationSuccess",
      "PostNotFound",
      "PostNotUpdated",
      "PostUpdated",
      "TagActionInIdeasSuccess"
    ],
    "CreateChannelGroupPayload": [
      "ChannelGroup",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "CreateCheckoutSessionPayload": [
      "BillingError",
      "CreateCheckoutSessionResponse"
    ],
    "CreateCustomChannelsPayload": [
      "CreateCustomChannelsResponse",
      "CustomChannelError"
    ],
    "CreateCustomerPortalSessionPayload": [
      "BillingError",
      "CreateCustomerPortalSessionResponse"
    ],
    "CreateFailedPostErrorPayload": [
      "CreateFailedPostErrorSuccess",
      "InvalidInputError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "CreateIdeaGroupPayload": [
      "IdeaGroup",
      "InvalidInputError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "CreateIdeaPayload": [
      "Idea",
      "IdeaResponse",
      "InvalidInputError",
      "LimitReachedError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "CreateOrUpdateFeedCollectionPayload": [
      "FeedCollectionActionSuccess",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "CreateOrUpdateFeedPayload": [
      "FeedActionSuccess",
      "FeedConnectionError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "CreateSavedReplyPayload": [
      "DuplicateError",
      "InvalidInputError",
      "LimitReachedError",
      "NotFoundError",
      "SavedReplyActionSuccess",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "CreateTagPayload": [
      "DuplicateError",
      "InvalidInputError",
      "LimitReachedError",
      "NotFoundError",
      "RestProxyError",
      "TagActionSuccess",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "CredentialsForChannelsPayload": [
      "CredentialsForChannelsError",
      "CredentialsForChannelsResponse"
    ],
    "CustomChannelUpdatePayload": [
      "CustomChannelUpdateResponse",
      "CustomChannelsError"
    ],
    "CustomChannelsCreatePayload": [
      "CustomChannelsCreateResponse",
      "CustomChannelsError"
    ],
    "Day": [
      "CalendarDay"
    ],
    "DeleteAccountPayload": [
      "DeleteAccountSuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnexpectedError"
    ],
    "DeleteAdminCommentPayload": [
      "EmptySuccess",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DeleteChannelGroupPayload": [
      "DeleteChannelGroupSuccess",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DeleteEntityNotePayload": [
      "CoreWebAppCommonError",
      "DeleteEntityNoteResponse"
    ],
    "DeleteFailedPostErrorPayload": [
      "DeleteFailedPostErrorSuccess",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DeleteFeedCollectionPayload": [
      "FeedCollectionDeleteSuccess",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DeleteFeedPayload": [
      "DeleteFeedResponse",
      "UnexpectedError"
    ],
    "DeleteIdeaGroupPayload": [
      "DeleteIdeaGroupResponse",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DeleteNoteFromPostPayload": [
      "DeleteNoteFromPostSuccess",
      "InvalidInputError",
      "LimitReachedError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DeletePostResult": [
      "DeletePostSuccess",
      "NotFoundError",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DeleteSavedReplyPayload": [
      "DeleteSavedReplySuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DeleteTagPayload": [
      "DeleteTagActionSuccess",
      "InvalidInputError",
      "NotFoundError",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DismissAllCommentsForChannelsPayload": [
      "DismissAllCommentsForChannelsSuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DismissAllCommentsPayload": [
      "DismissAllCommentsSuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DismissBannerPayload": [
      "DismissBannerError",
      "DismissBannerResponse"
    ],
    "DismissCommentPayload": [
      "DismissCommentSuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "DropPostPayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "EditEntityNotePayload": [
      "CoreWebAppCommonError",
      "EditEntityNoteResponse"
    ],
    "EmailNotificationPreferencePayload": [
      "EmailNotificationPreferenceError",
      "EmailNotificationPreferencesResponse"
    ],
    "FeedConnectionMetadata": [
      "NewsSearchConnectionMetadata",
      "RSSFeedConnectionMetadata"
    ],
    "FeedMoveUpdatesPayload": [
      "FeedMoveUpdatesResponse",
      "UnexpectedError"
    ],
    "GenerateTemplatedCompletionPayload": [
      "GenerateTemplatedCompletionSuccess",
      "LimitReachedError",
      "UnexpectedError"
    ],
    "GenericSubscription": [
      "MPSubscription",
      "OBSubscription"
    ],
    "GetAccessTokensForChannelPayload": [
      "AccessTokens",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "UnsupportedChannelError"
    ],
    "GoogleBusinessPostDetails": [
      "GoogleBusinessEventMetaData",
      "GoogleBusinessOfferMetaData",
      "GoogleBusinessWhatsNewMetaData"
    ],
    "HellonextSsoMutationResponse": [
      "Error",
      "HellonextSsoResponse",
      "UnverifiedEmailAddressError"
    ],
    "IdeaMutationPayload": [
      "CoreWebAppCommonError",
      "IdeaMutationSuccess"
    ],
    "IdeaPayload": [
      "CoreWebAppCommonError",
      "Idea"
    ],
    "IdeasCountByTagsPayload": [
      "CoreWebAppCommonError",
      "IdeasCountByTags"
    ],
    "IdeasCountPayload": [
      "CoreWebAppCommonError",
      "IdeasCount"
    ],
    "IdeasDeletionPayload": [
      "CoreWebAppCommonError",
      "IdeasDeletionSuccess"
    ],
    "ImageSearchPayload": [
      "ImageSearchError",
      "ImageSearchResponse"
    ],
    "ImpersonationResponse": [
      "Error",
      "Response"
    ],
    "InitiateEmailUpdateRequestPayload": [
      "InitiateEmailUpdateRequestSuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnexpectedError"
    ],
    "InitiateUpdateEmailPayload": [
      "EmptySuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnexpectedError"
    ],
    "ListFailedPostErrorsPayload": [
      "ListFailedPostErrorsSuccess",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "LoginVerificationResponsePayload": [
      "EmptySuccess",
      "UnexpectedError"
    ],
    "MarkNoteAuthorAsDeletedForOrganizationResponse": [
      "MarkNoteAuthorAsDeletedForOrganizationError",
      "MarkNoteAuthorAsDeletedForOrganizationSuccessResponse"
    ],
    "MoveIdeaGroupPayload": [
      "InvalidInputError",
      "MoveIdeaGroupResponse",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "MoveIdeaPayload": [
      "MoveIdeaResponse",
      "UnexpectedError"
    ],
    "MovePostToDraftsResult": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "MutationBasicError": [
      "BasicError",
      "ImageSearchError"
    ],
    "MutationBasicPayload": [
      "BasicError",
      "MutationBasicResponse"
    ],
    "MutationError": [
      "ChannelConnectionCannotStealChannelError",
      "ChannelConnectionNoChannelsError",
      "ChannelConnectionRefreshWrongAccountError",
      "ChannelRefreshRequired",
      "CustomChannelError",
      "DuplicateError",
      "InvalidInputError",
      "LimitReachedError",
      "NotFoundError",
      "RemoveSubscriptionScheduleError",
      "RestProxyError",
      "TooShortQueryStringError",
      "TransferError",
      "UnauthorizedError",
      "UnexpectedError",
      "UnsupportedChannelError",
      "VideoProcessingError",
      "VoidMutationError"
    ],
    "MutationResponse": [
      "BlockMutationSuccess",
      "BlocksMutationSuccess",
      "CommonMutationError",
      "CommonMutationResponse",
      "EngagementMutationResponse",
      "StartPageMutationSuccess"
    ],
    "MutationSuccess": [
      "BackfillUpdatesForGridResponse",
      "CancelTrialResponse",
      "DeleteAccountSuccess",
      "EmptySuccess",
      "InitiateEmailUpdateRequestSuccess",
      "RemoveAccountSuccess",
      "RemoveLegacyGlobalFeatureFlipSuccess",
      "SetPasswordSuccess",
      "UpdateAccountAvatarSuccess",
      "UpdateAccountNameSuccess",
      "UpdateLastActivityAtForChannelSuccess",
      "UpdateStartOfWeekPreferenceSuccess",
      "UpdateTimeFormatPreferenceSuccess",
      "VerifyPasswordSuccess"
    ],
    "OptimizePostingSchedulePayload": [
      "InvalidInputError",
      "NotFoundError",
      "OptimizePostingScheduleResponse",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "OrderChannelForAccountPayload": [
      "EmptySuccess",
      "NotFoundError",
      "UnexpectedError"
    ],
    "OrganizationFeatureUsageUpdateResponse": [
      "Error",
      "Response"
    ],
    "PaginatedIdeasPayload": [
      "CoreWebAppCommonError",
      "PaginatedIdeasList"
    ],
    "PlaceholderIdeasCreatedPayload": [
      "CoreWebAppCommonError",
      "PlaceholderIdeasMutationSuccess"
    ],
    "PostActionPayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "PostDeletionPayload": [
      "PostDeletionResponse",
      "PublishingError"
    ],
    "PostMetadata": [
      "BlueskyPostMetadata",
      "FacebookPostMetadata",
      "GoogleBusinessPostMetadata",
      "InstagramPostMetadata",
      "LinkedInPostMetadata",
      "MastodonPostMetadata",
      "PinterestPostMetadata",
      "StartPagePostMetadata",
      "ThreadsPostMetadata",
      "TiktokPostMetadata",
      "TwitterPostMetadata",
      "YoutubePostMetadata"
    ],
    "PostStatisticsV2": [
      "PostMetricLegacy",
      "PostMetricObject"
    ],
    "PostUpdatedPayload": [
      "CoreWebAppCommonError",
      "PostNotFound",
      "PostNotUpdated",
      "PostUpdated"
    ],
    "PublishPostNowPayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError",
      "VideoProcessingError"
    ],
    "PublishingPostAttachment": [
      "PublishingPostDestinationUrl",
      "PublishingPostFirstComment",
      "PublishingPostLink",
      "PublishingPostRetweet"
    ],
    "RefreshFeedCollectionPayload": [
      "FeedCollectionActionSuccess",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "RefreshFeedPayload": [
      "FeedActionSuccess",
      "FeedConnectionError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "RejectPostPayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "RemoveAccountPayload": [
      "InvalidInputError",
      "NotFoundError",
      "RemoveAccountSuccess",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "RemoveLegacyGlobalFeatureFlipPayload": [
      "InvalidInputError",
      "NotFoundError",
      "RemoveLegacyGlobalFeatureFlipSuccess",
      "UnexpectedError"
    ],
    "RemovePostScheduledTimePayload": [
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "RemoveSubscriptionSchedulePayload": [
      "RemoveSubscriptionScheduleError",
      "RemoveSubscriptionScheduleResponse"
    ],
    "ReorderPostsPayload": [
      "NotFoundError",
      "ReorderPostsSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "ReplyToCommentPayload": [
      "InvalidInputError",
      "NotFoundError",
      "ReplyToCommentSuccess",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "RequestPostApprovalPayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "RevertPostApprovalRequestPayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "RevokeAccessConnectedAppPayload": [
      "EmptySuccess",
      "UnexpectedError"
    ],
    "SchedulePostPayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "SchedulesPayload": [
      "SchedulesError",
      "SchedulesResponse"
    ],
    "ScrapedLink": [
      "LinkAttachment",
      "RetweetMetadata"
    ],
    "SearchThreadsLocationsPayload": [
      "ChannelRefreshRequired",
      "SearchThreadsLocationsResponse",
      "TooShortQueryStringError"
    ],
    "SendTestNotificationPayload": [
      "SendTestNotificationError",
      "SendTestNotificationSuccess"
    ],
    "SetPasswordForAccountPayload": [
      "InvalidInputError",
      "NotFoundError",
      "SetPasswordSuccess",
      "UnexpectedError"
    ],
    "SetPostingScheduleForChannelPayload": [
      "InvalidInputError",
      "NotFoundError",
      "SetPostingScheduleForChannelResponse",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "ShopGridCustomLinksMutationPayload": [
      "NotFoundError",
      "ShopGridCustomLinksPayload",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "StartPageBlock": [
      "StartPageBlockButtonLink",
      "StartPageBlockFeed",
      "StartPageBlockFeedPost",
      "StartPageBlockHeader",
      "StartPageBlockIconLinks",
      "StartPageBlockImageLink",
      "StartPageBlockImageLinksGrid",
      "StartPageBlockInstagramLinksGrid",
      "StartPageBlockMailchimp",
      "StartPageBlockSpotify",
      "StartPageBlockSubHeading",
      "StartPageBlockText",
      "StartPageBlockVideo"
    ],
    "StartPageMutationResponse": [
      "CommonError",
      "StartPageMutationSuccess"
    ],
    "StartPageResponse": [
      "CommonError",
      "StartPage"
    ],
    "StartPagesResponse": [
      "CommonError",
      "StartPages"
    ],
    "SwapPostsInQueuePayload": [
      "NotFoundError",
      "RestProxyError",
      "SwapPostsInQueueSuccess",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "TagActionInIdeasPayload": [
      "CoreWebAppCommonError",
      "TagActionInIdeasSuccess"
    ],
    "TextGenerationResponse": [
      "CommonError",
      "TextGenerated"
    ],
    "ThreadedPostMetadata": [
      "BlueskyPostMetadata",
      "MastodonPostMetadata",
      "ThreadsPostMetadata",
      "TwitterPostMetadata"
    ],
    "TrackExternalServiceUsageResponse": [
      "Error",
      "Response"
    ],
    "TransferOrganizationOwnershipPayload": [
      "EmptySuccess",
      "TransferError"
    ],
    "TwoFactorConfirmPayload": [
      "InvalidInputError",
      "TwoFactorConfirmResponse",
      "UnexpectedError"
    ],
    "TwoFactorDisablePayload": [
      "EmptySuccess",
      "UnexpectedError"
    ],
    "TwoFactorRecoveryCodePayload": [
      "InvalidInputError",
      "TwoFactorRecoveryCodeResponse",
      "UnexpectedError"
    ],
    "TwoFactorRequestOneTimePasswordPayload": [
      "EmptySuccess",
      "UnexpectedError"
    ],
    "TwoFactorSetupPayload": [
      "InvalidInputError",
      "TwoFactorSetupResponse",
      "UnexpectedError"
    ],
    "UndismissCommentPayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UndismissCommentSuccess",
      "UnexpectedError"
    ],
    "UpdateAccountAvatarPayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnexpectedError",
      "UpdateAccountAvatarSuccess"
    ],
    "UpdateAccountNamePayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "UpdateAccountNameSuccess"
    ],
    "UpdateAccountPreferencesPayload": [
      "InvalidInputError",
      "UpdateAccountPreferencesSuccess"
    ],
    "UpdateAccountTimezonePayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnexpectedError",
      "UpdateAccountTimezoneSuccess"
    ],
    "UpdateAdminCommentPayload": [
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "UpdateAdminCommentSuccess"
    ],
    "UpdateChannelGroupPayload": [
      "ChannelGroup",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "UpdateChannelPostingGoalPayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "UpdateChannelPostingGoalResponse"
    ],
    "UpdateCustomChannelPayload": [
      "CustomChannelError",
      "UpdateCustomChannelResponse"
    ],
    "UpdateCustomLinksColorsPayload": [
      "EmptySuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "UpdateFailedPostErrorPayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "UpdateFailedPostErrorSuccess"
    ],
    "UpdateIdeaGroupPayload": [
      "IdeaGroup",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "UpdateIdeaPayload": [
      "IdeaResponse",
      "InvalidInputError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "UpdateLastActivityAtForChannelPayload": [
      "UnauthorizedError",
      "UnexpectedError",
      "UpdateLastActivityAtForChannelSuccess"
    ],
    "UpdateNoteOnPostPayload": [
      "InvalidInputError",
      "LimitReachedError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "UpdateNoteOnPostSuccess"
    ],
    "UpdatePasswordPayload": [
      "EmptySuccess",
      "InvalidInputError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "UpdatePostDueAtMutationResponse": [
      "CoreWebAppCommonError",
      "PostNotFound",
      "PostNotUpdated",
      "PostUpdated"
    ],
    "UpdatePostTagsPayload": [
      "NotFoundError",
      "PostActionSuccess",
      "RestProxyError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "UpdateSavedReplyPayload": [
      "DuplicateError",
      "InvalidInputError",
      "NotFoundError",
      "SavedReplyActionSuccess",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "UpdateShopGridPostLinkPayload": [
      "EmptySuccess",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "UpdateStartOfWeekPreferencePayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "UpdateStartOfWeekPreferenceSuccess"
    ],
    "UpdateTagPayload": [
      "DuplicateError",
      "InvalidInputError",
      "NotFoundError",
      "RestProxyError",
      "TagActionSuccess",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "UpdateTimeFormatPreferencePayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "UpdateTimeFormatPreferenceSuccess"
    ],
    "UpdateTimezoneForChannelPayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "UpdateTimezoneForChannelResponse"
    ],
    "UploadPayload": [
      "CoreWebAppCommonError",
      "UploadDetails"
    ],
    "VerifyPasswordPayload": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UnexpectedError",
      "VerifyPasswordSuccess"
    ],
    "VerifyTfaCodePayload": [
      "InvalidInputError",
      "MutationBasicResponse",
      "NotFoundError",
      "UnexpectedError"
    ],
    "accountSetSettingsPayload": [
      "AccountSetSettingsError",
      "AccountSetSettingsResponse"
    ],
    "trackActionOnboardingSurveyPayload": [
      "InvalidInputError",
      "TrackActionOnboardingSurveySuccess",
      "UnauthorizedError",
      "UnexpectedError"
    ],
    "voteForFeatureMutationResponse": [
      "BasicError",
      "MutationBasicResponse"
    ]
  }
};
      export default result;
    